const dataProjects = [
    {
        project_name: "Grocery Mart",
        title: "Ecommerce website",
        desc: "Build and develop ecommerce website",
        tech: "HTML, CSS, SCSS, JS",
        link: "https://kietnm-ecommerce.vercel.app",
    },
    {
        project_name: "CeloBank",
        title: "Landing website",
        desc: "Build and develop landing website",
        tech: "HTML, CSS, SCSS, JS",
        link: "https://kietnm-landing-celobank.vercel.app",
    },
    {
        project_name: "Besnik",
        title: "Landing website",
        desc: "Build and develop landing website",
        tech: "HTML, CSS, JS",
        link: "https://kietnm-landing-besnik.vercel.app",
    },
    {
        project_name: "Dental Care",
        title: "Landing website",
        desc: "Build and develop landing website",
        tech: "HTML, CSS, JS",
        link: "https://kietnm-landing-dental-care.vercel.app",
    },
    {
        project_name: "Lesson",
        title: "Landing website",
        desc: "Build and develop landing website",
        tech: "HTML, CSS, JS",
        link: "https://kietnm-landing-lesson.vercel.app",
    },
    {
        project_name: "CRUD ReactJs",
        title: "Demo website",
        desc: "Build and develop demo website",
        tech: "ReactJs, NodeJs",
        link: "https://kietnm-reactjs.vercel.app",
    },
    {
        project_name: "CRUD NextJs",
        title: "Demo website",
        desc: "Build and develop demo website",
        tech: "NextJs (Typescript), NodeJs",
        link: "https://kietnm-nextjs.vercel.app",
    },
    {
        project_name: "ReactJs Formik Yup",
        title: "Demo website",
        desc: "Build and develop demo website",
        tech: "ReactJs, Formik, Yup",
        link: "https://kietnm-formik-yup.vercel.app",
    },
];

export default dataProjects;
